import React, { Component, useEffect, useState } from "react";
import {
    Button,
    Grid,
    CircularProgress,
   
} from "@material-ui/core";
import { PostApi, GetApi } from "../../../js_assets/Network";
import { useForm, Controller } from "react-hook-form";




function EditScheduleForm(props) {

    const Admin_Info = JSON.parse(localStorage.getItem("Admin_Info"))
    const [Isloading, setIsloading] = useState(false);

    const { getValues, setValue, handleSubmit, errors, register, watch } = useForm({});

    const values = watch();
    useEffect(() => {
        register("subscription_Schedule_Id", { required: true });
        register("subscription_Price", { required: true });
        register("number_Of_Added_Days", { required: true });
    }, []);


    useEffect(() => {
        if (props.data) {
            setValue("subscription_Schedule_Id", props.data.subscription_Schedule_Id);
            setValue("subscription_Price", props.data.subscription_Price);
            setValue("number_Of_Added_Days", 0)

        }
    }, [props.data]);



    function Save_New_Edit() {
        setIsloading(true)
        PostApi(
            `/api/admin/Update_Subscription_Schedule_Content_Date/${Admin_Info.admin_Id}`,
            {
                subscription_Schedule_Id: values.subscription_Schedule_Id,
                subscription_Price: parseFloat(values.subscription_Price),
                number_Of_Added_Days: parseInt(values.number_Of_Added_Days),
            },
            Admin_Info.jwT_Token_Admin
        ).then(() => {


            setIsloading(false)
            window.alert("تم تعديل الجدول ")
        });
    }

    return (

        <div style={{ width: 350, padding: 5 }}>
            <Grid justify="center" alignItems="center" container spacing={8} style={{ paddingTop: 25 }}>
                <h2>تعديل الاشتراك </h2>
                <hr />
            </Grid>
            <hr />
            <br />
            <span>سعر الاشتراك</span>
            <div >
                <input

                    placeholder="سعر الاشتراك"
                    name="subscription_Price"
                    value={values.subscription_Price}
                    onChange={e => setValue("subscription_Price", e.target.value)}
                />
            </div>


            <span> عدد الايام  المضافة</span>
            <div >
                <input

                    placeholder="سعر الاشتراك"
                    name="number_Of_Added_Days"
                    value={values.number_Of_Added_Days}
                    onChange={e => setValue("number_Of_Added_Days", e.target.value)}
                />
            </div>
            <Grid justify="center" alignItems="center" container spacing={8} style={{ marginTop:30,marginRight:30,width:"95%" }}>
                في حال انتهاء الاشتراك ورغبت في تفعيله مره اخرى يرجى اضافة ايام النظام تلقائي رح يفعل الاشتراك نفسه
            </Grid>


            <Grid justify="center" alignItems="center" container spacing={8} style={{ paddingTop: 40 }}>
                <button
                    variant="contained"
                    type="Submit"
                    color="primary"
                    // style={{ color: "white" }}
                    disabled={Isloading}
                    onClick={() => Save_New_Edit()}
                >
                    {Isloading == true ? (
                        <CircularProgress color={"secondary"} />
                    ) : (
                        "حفظ"
                    )}
                </button>
            </Grid>


        </div>


    );
}


export default EditScheduleForm;


